<template>
  <div id="hp-shop-service-component" role="region" :data-brand="brand.substr(0,1).toLowerCase() + brand.substr(1)">
    <div class="container">
      <div class="row">
        <div class="col-xs-12">
          <div class="shop-box">
            <ul class="nav nav-tabs" role="tablist">
              <li class="active" role="presentation">
                <a aria-controls="shop-filter" data-toggle="tab" href="#shop-filter" role="tab">Start Shopping</a>
              </li>
              <li role="presentation">
                <a aria-controls="service-filter" data-toggle="tab" href="#service-filter" role="tab">Get Service</a>
              </li>
            </ul>
            <div class="tab-content">
              <div class="tab-pane active" id="shop-filter" role="tabpanel">
                <div class="vehicle-browse-ajax">
                  <form class="vehicle-search-form" method="get">
                    <input class="inventory-type set-on-load" name="new" type="hidden" value="true">
                    <div class="form-group">
                      <label class="visuallyhidden" for="dropdown-vehicle-type">Select vehicle
                        type:</label>
                      <select aria-labelledby="dropdown-search-title" class="form-control vehicle-search search-inv-type" id="dropdown-vehicle-type" name="type">
                        <option data="true" value="new">New</option>
                        <option data="false" value="used">Used</option>
                      </select>
                      <i class="material-icons">keyboard_arrow_down</i>
                    </div>
                    <div class="form-group">
                      <label class="visuallyhidden" for="dropdown-vehicle-make">Select vehicle
                        make:</label>
                      <select aria-labelledby="dropdown-search-title" class="form-control vehicle-search vehicle-search-make" id="dropdown-vehicle-make" name="make">
                        <option value="default">{{brandName}}</option>
                      </select>
                      <i class="material-icons">keyboard_arrow_down</i>
                    </div>
                    <div class="form-group">
                      <label class="visuallyhidden" for="dropdown-vehicle-model">Select vehicle
                        model:</label>
                      <select aria-labelledby="dropdown-search-title" class="form-control vehicle-search vehicle-search-model" id="dropdown-vehicle-model" name="model">
                        <option value="default">Model</option>
                      </select>
                      <i class="material-icons">keyboard_arrow_down</i>
                    </div>
                    <div class="form-group">
                      <label class="visuallyhidden" for="dropdown-vehicle-year">Select vehicle
                        year:</label>
                      <select aria-labelledby="dropdown-search-title" class="form-control vehicle-search vehicle-search-year" id="dropdown-vehicle-year" name="year">
                        <option value="default">Year</option>
                      </select>
                      <i class="material-icons">keyboard_arrow_down</i>
                    </div>
                    <div class="form-group" id="search-submit">
                      <input aria-label="Click here to submit" class="btn btn-block btn-lg search-form-btn vehicle-search-submit" value="Search">
                    </div>
                  </form>
                  <br>
                  <span class="matching-vehicles-found text-center">
                    <div class="text-center">
                      <span class="match-count"><b>123</b></span>&nbsp; matching vehicles
                      found</div>
                  </span>
                </div>
                <div class="shop-inventory-buttons">
                  <div class="row">
                    <div class="col-sm-6 col-xs-12">
                      <a class="btn new-vehicles" href="#">Shop New Vehicles</a>
                    </div>
                    <div class="col-sm-6 col-xs-12">
                      <a class="btn pre-owned-vehicles" href="#">Shop Pre-Owned Vehicles</a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane" id="service-filter" role="tabpanel">
                <div class="service-buttons">
                  <div class="row">
                    <div class="col-sm-4 col-xs-12">
                      <a class="btn schedule-service" href="#">Book Service</a>
                    </div>
                    <div class="col-sm-4 col-xs-12">
                      <a class="btn order-parts" href="#">Order Parts</a>
                    </div>
                    <div class="col-sm-4 col-xs-12">
                      <a class="btn service-specials" href="#">Service Specials</a>
                    </div>
                  </div>
                </div>
                <div class="service-hours">
                  <div class="row">
                    <div class="col-xs-12 text-center">
                      <p>Service Department is open...</p>
                    </div>
                    <div class="col-sm-4 col-xs-12 text-center">
                      <div class="hours-box">
                        <span class="date">Mon - Fri</span><span>8:00 am - 5:00 pm</span>
                      </div>
                    </div>
                    <div class="col-sm-4 col-xs-12 text-center">
                      <div class="hours-box">
                        <span class="date">Sat</span><span>8:00 am - 5:00 pm</span>
                      </div>
                    </div>
                    <div class="col-sm-4 col-xs-12 text-center">
                      <div class="hours-box">
                        <span class="date">Sun</span><span>Closed</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      brand: this.$store.state.chosenBrand
    }
  },
  computed: {
    brandName () {
      if (this.brand === 'none') {
        return 'Brand';
      } else if (this.brand === 'infiniti' || this.brand === 'cjdr') {
        return this.brand.toUpperCase();
      } else {
        return this.brand.charAt(0).toUpperCase() + this.brand.slice(1);
      }
    }
  },
  mounted() {
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
.visuallyhidden {
  display: none;
}
#hp-shop-service-component {
  background: #F7F4F2;
  padding-top: 5%;
  padding-bottom: 5%;
  font-size: 14px;
  font-family: 'Helvetica Neue', Arial, sans-serif;
}
#hp-shop-service-component .shop-box {
  background: transparent;
  color: #000;
}
#hp-shop-service-component .shop-box .nav-tabs {
  background: transparent;
}
#hp-shop-service-component .shop-box .nav-tabs li {
  float: none;
  display: inline-block;
  width: 49%;
  text-align: center;
  background: #f5f5f5;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  border: 1px solid #ddd;
}
#hp-shop-service-component .shop-box .nav-tabs li.active {
  background: #fff;
  border-bottom-color: #fff;
}
#hp-shop-service-component .shop-box .nav-tabs li:last-of-type {
  float: right;
}
#hp-shop-service-component .shop-box .nav-tabs li a {
  font-weight: 500;
  font-size: 16px;
  color: #58595B;
  border: none !important;
}
#hp-shop-service-component .shop-box .nav-tabs li.active a {
  color: #000;
}
#hp-shop-service-component .shop-box .nav-tabs li:after {
  content: " ";
  display: block;
  height: 2px;
  width: 200px;
  background: transparent;
  margin: auto;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all .3s ease;
}
#hp-shop-service-component .shop-box .nav-tabs li.active:after {
  background: var(--primary-color);
}
#hp-shop-service-component[data-brand="cjdr"] .shop-box .nav-tabs li.active:after {
  background: var(--secondary-color);
}
#hp-shop-service-component .tab-pane {
  padding: 30px 15px 15px;
  background: #fff;
  border: 1px solid #ddd;
  border-top-color: #fff;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}
#hp-shop-service-component #shop-filter.active {
  background-color: #fff;
  margin: auto;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  overflow: hidden;
  background-size: cover;
}
#hp-shop-service-component .vehicle-browse-ajax {
  width: 100%;
  max-width: 1024px;
  margin: 0 auto 25px;
  z-index: 2;
}
#hp-shop-service-component .form-group {
  flex-grow: 1;
  position: relative;
  border-radius: 6px;
}
#hp-shop-service-component .form-group:not(#search-submit) {
  background-color: #fff;
}
#hp-shop-service-component .form-group i {
  position: absolute;
  line-height: 48px;
  right: 12px;
  top: 0;
}
#hp-shop-service-component .form-control {
  display: block;
  width: 100%;
  height: 100%;
  line-height: 32px;
  border-radius: 6px;
  position: relative;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  z-index: 1;
  background-color: transparent;
}
#hp-shop-service-component .search-form-btn.vehicle-search-submit {
  background-color: var(--primary-color);
  color: #fff;
  border: none;
  border-radius: 6px;
  text-transform: uppercase;
  letter-spacing: 2px;
  line-height: 32px;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all .3s ease;
}
#hp-shop-service-component[data-brand="cjdr"] .search-form-btn.vehicle-search-submit {
  background: var(--secondary-color);
}
#hp-shop-service-component .search-form-btn.vehicle-search-submit:hover {
  opacity: .75;
  color: #fff;
}
#hp-shop-service-component .matching-vehicles-found {
  color: #333;
  font-size: 16px;
}
#hp-shop-service-component .shop-inventory-buttons .btn, #hp-shop-service-component .service-buttons .btn {
  background: #29404D;
  color: #fff;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 2px;
  text-transform: uppercase;
  padding: 20px;
  width: 100%;
  display: block;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all .3s ease;
}
#hp-shop-service-component .shop-inventory-buttons .btn:hover, #hp-shop-service-component .service-buttons .btn:hover {
  background: #17242c;
}
#hp-shop-service-component #service-filter .service-hours {
  margin-top: 35px;
}
#hp-shop-service-component #service-filter .service-hours .col-xs-12 p {
  font-size: 14px;
  margin-bottom: 15px;
}
#hp-shop-service-component #service-filter .hours-box {
  background: #f5f5f5;
  border-radius: 5px;
  padding: 5px;
}
#hp-shop-service-component #service-filter .hours-box .date {
  color: #58595B;
  margin-right: 10px;
}

@media(min-width: 768px) {
  #hp-shop-service-component .vehicle-search-form {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    justify-content: space-between;
  }
  #hp-shop-service-component .form-group {
    flex-basis: 20%;
  }
  #hp-shop-service-component .form-group:not(:last-child) {
    margin-right: 12px;
  }
}

@media (max-width: 767px) {
  #hp-shop-service-component #service-filter .hours-box, #hp-shop-service-component .shop-inventory-buttons .btn, #hp-shop-service-component .service-buttons .btn {
    margin-bottom: 10px;
    padding-left: 0px;
    padding-right: 0px;
  }
  #hp-shop-service-component .shop-box .nav-tabs li:after {
    width: 120px;
  }
  #hp-shop-service-component .container {
    width: 100%;
  }
  #hp-shop-service-component .shop-box .nav-tabs li a {
    font-size: 14px;
  }
}
</style>